import * as React from "react";
import type { SVGProps } from "react";
const SvgLinkBreak = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#FF577A"
      d="M24.829 7.171a4 4 0 0 0-5.649-.007L17.724 8.69a1 1 0 0 1-1.448-1.375l1.465-1.536.017-.016a6 6 0 0 1 8.468 8.5L24.69 15.73a1 1 0 0 1-1.375-1.448l1.526-1.456a4 4 0 0 0-.012-5.654M14.276 23.31l-1.456 1.526a4 4 0 0 1-5.656-5.656l1.526-1.456a1 1 0 0 0-1.375-1.448l-1.541 1.465-.016.017a6 6 0 0 0 8.5 8.468l1.466-1.536a1.001 1.001 0 1 0-1.448-1.375zM27 19h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2M5 13h3a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2m15 10a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1M12 9a1 1 0 0 0 1-1V5a1 1 0 0 0-2 0v3a1 1 0 0 0 1 1"
    />
  </svg>
);
export default SvgLinkBreak;
